import { CourseAddOn, OccurrenceAddOn, SelectedOffers } from '@shared/types';
import { FunctionComponent } from 'react';
import { QuantityCard } from '../QuantityCard';

export type AddOnsSelectProps = {
    addOns: Array<CourseAddOn | OccurrenceAddOn>;
    selectedAddOns: SelectedOffers;
    hidePricing?: boolean;
    setSelectedAddOns: (selectedOffers: SelectedOffers) => unknown;
    currency: string;
};

export const AddOnsSelect: FunctionComponent<AddOnsSelectProps> = ({
    addOns,
    selectedAddOns,
    hidePricing,
    setSelectedAddOns,
    currency,
}) => {
    return (
        <ul>
            {addOns.map((addOn) => {
                const value = selectedAddOns[addOn._id] || 0;
                const onChange = (newQuantity: number) => {
                    if (newQuantity === 0) {
                        const withoutAddOn = { ...selectedAddOns };
                        delete withoutAddOn[addOn._id];
                        return setSelectedAddOns(withoutAddOn);
                    }
                    setSelectedAddOns({
                        ...selectedAddOns,
                        [addOn._id]: newQuantity,
                    });
                };
                return (
                    <li key={addOn._id}>
                        <QuantityCard
                            name={addOn.name || ''}
                            description={addOn.description}
                            price={addOn.price}
                            quantity={value}
                            maximumQuantity={Infinity}
                            hidePricing={hidePricing}
                            onChange={onChange}
                            currency={currency}
                        />
                    </li>
                );
            })}
        </ul>
    );
};
